import React, { useState } from 'react';
import { Autocomplete } from './common/Autocomplete';
import { orderBy } from 'lodash';
import { Contractor, Outlet } from 'src/shared/api';

interface Props {
  onSelect?: (contractor: Outlet | null) => any;
  outlets?: Outlet[] | null;
}

export const OutletSelect: React.FunctionComponent<Props> = ({
  onSelect,
  outlets,
}) => {

  const [query, setQuert] = useState('');

  return (
    <div>
      <Autocomplete
        label="Торговая точка"
        options={orderBy(outlets || [], ['name'])}
        onChange={(e, value: Contractor) => onSelect && onSelect(value)}
        onChangeTextField={e => setQuert(e.target.value)}
        getOptionLabel={option => {
          return `${option.address.line} (${option.name} )`;
        }}
      />
    </div>
  );
};
